import { render, staticRenderFns } from "./NetworkStatusBadge.vue?vue&type=template&id=ba7a8276&scoped=true&"
import script from "./NetworkStatusBadge.vue?vue&type=script&lang=js&"
export * from "./NetworkStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./NetworkStatusBadge.vue?vue&type=style&index=0&id=ba7a8276&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7a8276",
  null
  
)

export default component.exports